/*
  ПЛЪЗГАНЕТО НА ОБЛОЖКИТЕ В РЕШЕТКАТА.

  Самото плъзгане не е тук — то е браузърно (`scroll-snap` в стила). Тук са
  само двете неща, които CSS не може: кога да се изтеглят снимките и коя точка
  свети.

  ЗАЩО СНИМКИТЕ НЕ СЕ ТЕГЛЯТ ВЕДНАГА. 193 от 250 плочи имат втора снимка. В
  решетка от двайсет и четири карти това е двойно повече теглене, за да се
  види може би една — а `loading="lazy"` не помага: за браузъра кадърът
  настрани е в екрана и той го дърпа. Затова вторите кадри идват без `src` и
  го получават при първото посочване или докосване на тяхната лента.

  ЕДИН СЛУШАТЕЛ ЗА ЦЯЛАТА СТРАНИЦА, не по един на карта: лентите са толкова,
  колкото са плочите в решетката.
*/
(() => {
  const лентата = (цел) => (цел instanceof Element ? цел.closest('[data-gm-swipe]') : null);

  const напълни = (лента) => {
    if (лента.dataset.gmFilled) return;
    лента.dataset.gmFilled = '1';
    лента.querySelectorAll('img[data-gm-src]').forEach((кадър) => {
      кадър.src = кадър.dataset.gmSrc;
      кадър.removeAttribute('data-gm-src');
    });
  };

  const отбележи = (лента) => {
    const точки = лента.parentElement?.querySelectorAll('.gm-swipe__dot');
    if (!точки || !точки.length) return;
    const широчина = лента.clientWidth;
    if (!широчина) return;
    // Math.abs: при писменост отдясно наляво `scrollLeft` е отрицателно.
    const кой = Math.round(Math.abs(лента.scrollLeft) / широчина);
    точки.forEach((точка, i) => точка.classList.toggle('is-on', i === кой));
  };

  // Посочване и докосване вървят в едно: `pointerover` се вдига и от мишка, и
  // от пръст, тоест снимката тръгва към човека, преди да е доплъзгал.
  addEventListener(
    'pointerover',
    (събитие) => {
      const лента = лентата(събитие.target);
      if (лента) напълни(лента);
    },
    { passive: true, capture: true }
  );

  // Скролът НЕ бълбука, но се улавя в етапа на спускане — затова един слушател
  // на прозореца вижда всички ленти.
  //
  // БЕЗ ОГРАНИЧАВАНЕ ПО КАДЪР, макар да се напрашва. Първият вариант пропускаше
  // събитията, докато чака `requestAnimationFrame` — и изяждаше ПОСЛЕДНОТО,
  // онова, което носи крайното положение. Мерено: плъзгане до кадър 2 и обратно
  // оставяше да свети втората точка. Браузърът и без това вдига скрола най-много
  // веднъж на кадър, а отбелязването чете две числа и превключва до четири класа.
  addEventListener(
    'scroll',
    (събитие) => {
      const лента = лентата(събитие.target);
      if (!лента) return;
      напълни(лента);
      отбележи(лента);
    },
    { passive: true, capture: true }
  );
})();
